import { atom } from "jotai";
import { AtomSetter } from "./types";

type IReTranscriptionProgressAtom = Record<string, boolean>;

export const reTranscriptionProgressAtom = atom<IReTranscriptionProgressAtom>(
    {}
);

export const setRetrancriptionProgressByInterviewID = (
    set: AtomSetter<IReTranscriptionProgressAtom>,
    interviewID: string,
    isInProgress: boolean
) => {
    set((prevState) => {
        const newState = { ...prevState };

        if (isInProgress) {
            newState[interviewID] = isInProgress;
        } else {
            delete newState[interviewID];
        }

        return newState;
    });
};
